import { render, staticRenderFns } from "./ProductionDash.vue?vue&type=template&id=54995d3a&"
import script from "./ProductionDash.vue?vue&type=script&lang=js&"
export * from "./ProductionDash.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDash.vue?vue&type=style&index=0&id=54995d3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports